<script setup lang="ts">
import AgencySearchBar from '@/components/AgencySearchBar/AgencySearchBar.vue';
</script>

<template>
  <div :class="$style.heroBannerWrapper">
    <div class="layout-container">
      <AgencySearchBar />
    </div>
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.heroBannerWrapper {
  background-color: $color-white;
}
</style>
